import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Anchor, Button, Grid, GridColumn, Heading, Separator, Tag, Text } from 'telia-front-react';
import { languageSlug } from '../stores/LanguageStore';
import { useStores } from '../stores/RootStore';

export interface NewsProps {
  rootPath?: string;
  columns?: number;
  buttonUrl?: string;
  showHeading?: boolean;
  showCTA?: boolean;
}

const DEFAULT_COLUMNS = 3;

const News = (props: NewsProps): React.JSX.Element => {
  const {
    languageStore: { currentLanguage },
    newsStore: { loadNews, getNewsItemsForPage },
  } = useStores();
  const { columns, buttonUrl, rootPath, showHeading = true, showCTA = true } = props;
  const { translate } = React.useContext(TranslationsContext);

  React.useEffect(() => {
    loadNews(columns || DEFAULT_COLUMNS);
  }, []);

  const columnsToShow = columns || DEFAULT_COLUMNS;
  const newsItems = getNewsItemsForPage(columnsToShow);
  const resolvedRootPath = `${languageSlug(currentLanguage)}${rootPath || '/uudised/'}`;

  if (!newsItems?.length) {
    return null;
  }

  return (
    <>
      {showHeading && <Heading element={'h2'}>{translate('news.title')}</Heading>}
      <Separator color={'invisible'} spacing={'xsmall'} />
      <Grid element="ul">
        {newsItems.map((news) => (
          <GridColumn width={['xs-12', 'md-6', columnsToShow < 4 ? 'lg-4' : 'lg-3']} key={news.id}>
            <Tag text={translate('news.tagTitle')} size="tiny" purpose="recommended" />
            <Text>
              <Separator spacing="xxsmall" color="invisible" />
              <p className="text-tiny text__margin-none">
                <time dateTime={news.date}>{news.displayDate}</time>
              </p>
              <AnalyticsTrigger trigger={{ id: `Link - ${news.title}`, callback: 'onClick' }}>
                <Anchor url={`${resolvedRootPath}${news.slug}`} isTextColor={true} isUnderlined={false} className="text-weight-normal h4">
                  {news.title}
                </Anchor>
              </AnalyticsTrigger>
            </Text>
          </GridColumn>
        ))}
      </Grid>
      {showCTA && (
        <>
          <Separator color={'invisible'} spacing={'xsmall'} />
          <AnalyticsTrigger trigger={{ id: 'Link - News', callback: 'onClick' }}>
            <Button text={translate('newsDetails.viewAllButtonText')} iconRight={'#arrow-right'} variant={'secondary'} url={buttonUrl || resolvedRootPath} />
          </AnalyticsTrigger>
        </>
      )}
    </>
  );
};

export default observer(News);
